/**
 * @file   src\components\CWTeaxtarea.tsx
 * @brief  Html CWTextarea component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import {React} from '../utils/thirdpartyComponents'
import { useEffect, useRef } from 'react';
import { ITextAreaProperty } from '../interfaces/generalInterface';
import "../components/CWInput.scss";

const CWTextarea = ({ rows, label, errorMessage, value, id, name, placeholder, disabled, maxLength, helptext, isMandatory, autoFocus, charCount, onChange }: ITextAreaProperty) => {
  const textareaRef: any = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      textareaRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className="form-group cw-textarea">
      <div className="textarea-group">
        <label htmlFor="label">
          {label}
          {isMandatory && <span className="mandatory">*</span>}
        </label>
        <textarea
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value && value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onChange && onChange(event)}
          ref={textareaRef}
          rows={rows}
        />
        {/* <small className="help-text">{helptext}</small> */}
        <span className='counter-value d-flex justify-content-end'>{charCount}/{maxLength}</span>
        {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
      </div>
    </div>
  );
};

export default CWTextarea;
